import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Mail, Trash2, Download } from "lucide-react";

export default function NewsletterManager() {
  const [subs, setSubs] = useState([]);

  const load = () => api.get("/cms/newsletter").then(({ data }) => setSubs(data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Eintrag wirklich entfernen?")) return;
    await api.delete(`/cms/newsletter/${id}`);
    load();
  };

  const exportCsv = () => {
    const rows = [["email", "name", "subscribed_at"], ...subs.map((s) => [s.email, s.name || "", s.subscribed_at])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-8 lg:p-12 mv-fade-in">
      <div className="flex items-end justify-between mb-10">
        <div>
          <p className="mv-label mb-2">Abonnenten</p>
          <h1 className="font-display text-4xl">Newsletter</h1>
          <p className="text-sm mt-2" style={{ color: "var(--mv-text-muted)" }}>{subs.length} Anmeldungen</p>
        </div>
        <button data-testid="export-csv-btn" onClick={exportCsv} className="mv-btn-ghost"><Download className="w-4 h-4" strokeWidth={1.5} /> Als CSV exportieren</button>
      </div>

      {subs.length === 0 ? (
        <div className="mv-card p-12 text-center">
          <Mail className="w-8 h-8 mx-auto mb-3 opacity-50" strokeWidth={1.5} />
          <p style={{ color: "var(--mv-text-muted)" }}>Noch keine Anmeldungen. Newsletter-Formular ist im Footer aktiv, wenn aktiviert.</p>
        </div>
      ) : (
        <div className="mv-card overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr style={{ background: "var(--mv-surface)" }}>
                <th className="text-left px-5 py-3 mv-label" style={{ color: "var(--mv-text-muted)" }}>E-Mail</th>
                <th className="text-left px-5 py-3 mv-label" style={{ color: "var(--mv-text-muted)" }}>Name</th>
                <th className="text-left px-5 py-3 mv-label" style={{ color: "var(--mv-text-muted)" }}>Datum</th>
                <th className="w-12"></th>
              </tr>
            </thead>
            <tbody>
              {subs.map((s) => (
                <tr key={s.id} className="border-t" style={{ borderColor: "var(--mv-border)" }}>
                  <td className="px-5 py-3">{s.email}</td>
                  <td className="px-5 py-3" style={{ color: "var(--mv-text-muted)" }}>{s.name || "—"}</td>
                  <td className="px-5 py-3 text-xs" style={{ color: "var(--mv-text-muted)" }}>{new Date(s.subscribed_at).toLocaleDateString("de-DE", { year: "numeric", month: "short", day: "numeric" })}</td>
                  <td className="px-2"><button data-testid={`delete-sub-${s.id}`} onClick={() => remove(s.id)} className="p-2 opacity-60 hover:opacity-100"><Trash2 className="w-4 h-4" strokeWidth={1.5} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
